import type { SchemaInput } from './schema-input.js';
import { isNumber } from './runtime-values.js';

export function normalizeUnitOpacity(value: SchemaInput): number {
  const opacity = isNumber(value) ? value : Number(value);
  return Number.isFinite(opacity) ? Math.max(0, Math.min(1, opacity)) : 1;
}

export function normalizeStrokeOpacity(value: SchemaInput): number {
  const opacity = isNumber(value) ? value : Number(value);
  if (!Number.isFinite(opacity)) return 1;
  if (opacity <= 0) return 0;
  return Math.max(0.1, Math.min(1, opacity));
}

/** Convert old polygon opacity once, when drawing data enters the app. */
export function normalizePolygonOpacity(stroke: { tool?: string; opacity?: number; outlineOpacity?: number; fillOpacity?: number }): void {
  if (stroke.tool !== 'polygon') return;
  const fillOpacity = stroke.fillOpacity === undefined ? 0.25 : normalizeUnitOpacity(stroke.fillOpacity);
  const opacity = normalizeStrokeOpacity(stroke.opacity);
  stroke.fillOpacity = stroke.outlineOpacity === undefined ? opacity * fillOpacity : fillOpacity;
  stroke.outlineOpacity = stroke.outlineOpacity === undefined ? opacity : normalizeUnitOpacity(stroke.outlineOpacity);
  delete stroke.opacity;
}
